var NumberInputModule = (function () {
    function NumberInputModule() {
    }
    return NumberInputModule;
}());
export { NumberInputModule };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/number-input/number-input.module.ts.pre-build-optimizer.js